import axios from "axios";
import React, { useEffect, useState } from "react";
import fav from '../../../assets/favorite.svg';
import disenamos from '../../../assets/_disenos.svg';
import embalaje from '../../../assets/__embalaje_1.svg';
import cuotas from '../../../assets/_cuotas.svg';
import envios from '../../../assets/_envios.svg';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from "react-redux";
import { getCarrito } from "../../../redux/actions";
import { trackEvent } from "../../../utils/fbpPixel";
import Header from "../../../Components/Header/Header";
import HeaderLower from "../../../Components/HeaderLower/HeaderLower";

function Confirmacion() {
    const location = useLocation();
    const { idPedido } = useParams();
    const searchParams = new URLSearchParams(location.search);
    const cupones = searchParams.get('cupon');
    const [isRequestSent, setRequestSent] = useState(false);
    const carritoSinFiltro = useSelector((state) => state.carrito);
    const carrito = carritoSinFiltro.length !== 0 ? carritoSinFiltro.filter((item) => Number(item.precio_dolar) !== 0) : JSON.parse(localStorage.getItem('carrito'));
    const dolar = localStorage.getItem('dolar');
    const totalPrecio = localStorage.getItem('totalPrecio');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('token');
    const pago = searchParams.get('pago');
    const [localidades, setLocalidades] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [medioPago, setMedioPago] = useState('');
    const [medioPagoEmail, setMedioPagoEmail] = useState('');
    const [actualizoIdPedido, setActualizoIdPedido] = useState('');
    const total = localStorage.getItem('total');
    const domicilio = JSON.parse(localStorage.getItem('domicilio'));
    const retiro = localStorage.getItem('personal');
    const idPago = localStorage.getItem('idpago');
    const mediopago = pago || localStorage.getItem('mediopago');
    const envio = Number(localStorage.getItem('envio'));

    useEffect(() => {
        fetchProvincias();
        fetchLocalidades(domicilio?.fk_idprov);
        carrito && trackEvent('Purchase', {
            content_ids: carrito?.map(item => String(item.idproducto)), // IDs de productos en el carrito
            content_type: 'product', // Tipo de contenido
            value: total, // Valor total del carrito
            currency: 'ARS' // Moneda
        });
    }, [])

    const axiosPost = async (url, data) => {
        return await axios.post(url, {
            httpMethod: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
            isBase64Encoded: false,
        });
    };

    const fetchLocalidades = async (fk_idprov) => {
        const response = await axiosPost('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce/conseguir-localidades', { fk_idprov });
        const localidadesData = JSON.parse(response?.data?.body);
        setLocalidades(localidadesData);
    };

    const fetchProvincias = async () => {
        const response = await fetch('https://api.depcsuite.com/td/getProvincias?id=12', {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        setProvincias(await response.json());
    };

    const mapaLocalidades = {};
    localidades?.forEach(localidad => {
        mapaLocalidades[localidad.idlocalidad] = localidad.nombre;
    });

    const mapaProvincias = {};

    provincias?.forEach(provincia => {
        mapaProvincias[provincia.idprov] = provincia.descprov;
    });

    useEffect(() => {
        switch (mediopago) {
            case '1':
                setMedioPago('Transferencia Bancaria');
                setMedioPagoEmail('Transferencia Bancaria');
                break;
            case '20':
                setMedioPago('MercadoPago');
                setMedioPagoEmail('MercadoPago');
                break;
            case '25':
                setMedioPago('Transferencia por MODO')
                setMedioPagoEmail('Transferencia por MODO')
                break;
            default:
                break;
        }
        setActualizoIdPedido(idPedido)
    }, []);

    const now = new Date();

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();

    const currentDateFormatted = `${day}/${month}/${year}`;

    return (
        <div className="pb-[65px]">
            <Header/>
            <HeaderLower/>
            <div className="text-left lg:ml-10 pt-32">
                <p className="font-semibold text-[25px]">¡Recibimos tu pedido!</p>
                <p className="mt-6 mb-3 text-xl flex flex-row">Número de pedido: <p className="font-semibold ml-1">#{idPedido || actualizoIdPedido}</p></p>
                <p className="mt-10 text-center uppercase lg:text-left text-5xl mb-10 font-semibold">¡Muchas Gracias!</p>
                <p className="mt-14 text-center lg:text-left text-[#E40F1B] font-semibold uppercase">Importante:</p>
                <p className="lg:w-1/2 text-center lg:text-left text-[#E40F1B] ">Recordá que la entrega de los productos se realiza en la puerta del domicilio. El envío no incluye subida por escaleras ni armado de los productos.</p>
                <div className="flex flex-row overflow-x-auto lg:ml-0 mt-12">
                    <div className="flex flex-col mt-6">
                        <p className="font-semibold mt-3 mb-4">Estado de tu pedido</p>
                        <div className="absolute border lg:w-[90%] w-full -z-10 mt-10 border-b-2 border-[#E40F1B]"></div>
                        <p className="text-sm w-60">Te notificaremos al mail cuando tu pedido cambie de estado. También podés hacer el seguimiento en "Mi Perfil".</p>
                    </div>
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-col ml-20 items-center">
                            <p className={`text-[10px] lg:mt-5 mt-3 font-semibold`}>Pedido recibido</p>
                            <img src={disenamos} className="w-10 my-2 border-[2px] border-[#E40F1B] rounded-full" alt="" />
                            <p className={`text-[10px] font-semibold`}>{currentDateFormatted}</p>
                        </div>
                        <div className="flex flex-col lg:mt-5 mt-3 ml-20 items-center">
                            <p className={`text-[10px]  ${mediopago !== 20 ? 'opacity-70' : ''} font-semibold`}>Pago pendiente</p>
                            <img src={cuotas} className="w-10 my-2 border-[2px] border-[#E40F1B] rounded-full" alt="" />
                            <p className={`text-[10px]  ${mediopago !== 20 ? 'opacity-70' : ''} font-semibold`}>{mediopago !== 20 ? '--/--/----' : currentDateFormatted}</p>
                        </div>
                        <div className="flex flex-col ml-20 items-center">
                            <p className={`text-[10px] opacity-70 font-semibold mt-1 w-40 text-center`}>Pedido pendiente de preparación</p>
                            <img src={embalaje} className="w-10 mt-3 mb-2 border-[2px] border-[#E40F1B] rounded-full" alt="" />
                            <p className={`text-[10px]  opacity-70 font-semibold`}>--/--/----</p>
                        </div>
                        <div className="flex flex-col lg:mt-5 mt-3 ml-20 items-center">
                            <p className="text-[10px] font-semibold opacity-70">Envío pendiente</p>
                            <img src={envios} className="w-10 my-2 border-[2px] border-[#E40F1B] rounded-full" alt="" />
                            <p className="text-[10px] font-semibold opacity-70">--/--/----</p>
                        </div>
                        <div className="flex flex-col lg:mt-5 mt-3 ml-20 items-center">
                            <p className="text-[10px] font-semibold opacity-70">Entrega estimada</p>
                            <img src={fav} className="w-10 p-2 bg-gray-100 my-2 border-[2px] object-cover border-[#E40F1B] rounded-full" alt="" />
                            <p className="text-[10px] font-semibold opacity-70">--/--/----</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Confirmacion;